import React, { useState, useMemo, useEffect } from 'react';
import { TableColumn } from 'tea-component';
import { formatExeclNormalPercent, formatExeclNum, formatNum, formatPercentNum, getChartDateFormatString } from '@/pages/dashboard/utils/utils';
import { useLocal, useWeekDay } from '@/pages/dashboard/utils/customHook';
import { connect, getLocale } from 'umi';
import ChurnChartCo from './ChurnChartCo';
import { getExplainVal } from '@/pages/dashboard/utils/getExplainVal';
import { cloneDeep } from 'lodash-es';
import { addChartLabel } from '@/pages/dashboard/components/Chart/_config/plug';
import { getEchartTooltipText } from '@/pages/dashboard/components/EchartsBubble';
import moment from 'moment';


const WeekChurnUsersNightingaleContext = (props: any) => {
  const { getLocalText } = useLocal();
  const locale = getLocale();
  const { getWeekDay } = useWeekDay();
  const isEN = locale == 'en-US';

  const { explainInfo } = props;
  const defaultConfig = {
    timeType: 'Day',
    configTabList: [
      {
        cnText: '新增流失用户',
        enText: 'New Churn Users',
        value: 'newChurn'
      }, {
        cnText: '累计流失',
        enText: 'Accumulated',
        value: 'accumulated'
      }
    ],
    enTitle: 'Churn Users and Churn%',
    cnTitle: '流失用户和流失率',
    hideConfig: {

    },
    tab: 'newChurn',
    apiKey: {
      accChart: {
        churn_ratio: 'acc_churn_rate',
        churn_users: 'acc_churn_users'
      },
      newChart: {
        churn_users: 'new_churn_users'
      }
    },
    cnEChartTilte: '',
    enEChartTilte: '',
    cnEChartMetricsName: '',
    enEChartMetricsName: '',
    defaultActive: 1,
    titleDes: {
      title: '',
      isRainbow: true,
      content: 'Churn Users and Churn%',
      rainbowKey: 'Churn Users and Churn%',
      contentEn: '',
      contentCn: ''
    },
    multiChartTitle: [
      {
        en: 'Churn Users',
        cn: '流失用户'
      },
      {
        en: 'Churn%',
        cn: '流失率'
      }
    ]
  };

  const {
    timeType = defaultConfig.timeType,
    enTitle = defaultConfig.enTitle,
    cnTitle = defaultConfig.cnTitle,
    hideConfig = defaultConfig.hideConfig,
    configTabList = defaultConfig.configTabList,
    tab = defaultConfig.tab,
    apiKey = defaultConfig.apiKey,
    cnEChartTilte = defaultConfig.cnEChartTilte,
    enEChartTilte = defaultConfig.enEChartTilte,
    cnEChartMetricsName = defaultConfig.cnEChartMetricsName,
    enEChartMetricsName = defaultConfig.enEChartMetricsName,
    defaultActive = defaultConfig.defaultActive,
    titleDesConfig = defaultConfig.titleDes,
    multiChartTitle = defaultConfig.multiChartTitle
  } = props?.config;

  const metricsData = props?.data?.data || {};
  const { data, loading: isLoading, errorMsg: isError } = metricsData || {};
  const isNoData = data?.length <= 0;


  const [tabName, setTabName] = useState(tab);
  const [accChartData, setAccChartData] = useState([]);
  const [newChartData, setNewChartData] = useState([]);
  const [isEye, setIsEye] = useState(true);

  const title = isEN ? enTitle : cnTitle;
  const EChartTitle = isEN ? enEChartTilte : cnEChartTilte;
  const EChartMetricsName = isEN ? enEChartMetricsName : cnEChartMetricsName;

  const doubleChartTitle = multiChartTitle.map((v) => {
    return isEN ? v.en : v.cn;
  });

  const tabList = configTabList.map((v: { enText: string; cnText: string; value: string | number; }) => {
    return {
      text: isEN ? v.enText : v.cnText,
      value: v.value
    };
  });
  const explain = getExplainVal(explainInfo, titleDesConfig?.rainbowKey, getLocale(), titleDesConfig?.explainEn, titleDesConfig?.explainCn);
  const titleDes: any = [
    {
      title: titleDesConfig.title,
      content: titleDesConfig.isRainbow ? explain : isEN ? titleDesConfig.contentEn : titleDesConfig.contentCn
    },
  ];

  useEffect(() => {
    const data_list: Array<listItem> = data || [];
    const newChurn: any[] = [];
    const accChurn: any[] = [];

    data_list?.forEach(({ date, metrics }) => {
      newChurn.push({
        x: date,
        churn_users: metrics?.[apiKey.newChart.churn_users]?.value || ''
      });
      accChurn.push({
        x: date,
        churn_ratio: metrics?.[apiKey.accChart.churn_ratio]?.value || '',
        churn_users: metrics?.[apiKey.accChart.churn_users]?.value || ''
      });
    });

    // 双轴配置数据（柱状图双轴得自定义配置）
    const newChart = [getLocalText('engagement_churn_Churn_Users')].reduce((pre, name, index) => {
      if (newChurn.length) {
        const chartData = {
          name,
          type: 'bar',
          barCategoryGap: '50%',
          data: newChurn.map((item) => {
            const { x, churn_users, churn_ratio } = item;
            return {
              x,
              y: churn_users,
            };
          }),
        };
        pre.push(chartData);
      }
      return pre;
    }, [] as any[]);

    const accChart = doubleChartTitle.reduce((pre, name, index) => {
      if (accChurn.length) {
        const chartData = {
          name,
          type: index ? 'line' : 'bar',
          barCategoryGap: '50%',
          data: accChurn.map((item) => {
            const { x, churn_users, churn_ratio } = item;
            return {
              x,
              y: index ? churn_ratio : churn_users,
            };
          }),
        };
        pre.push(chartData);
      }
      return pre;
    }, [] as any[]);

    setAccChartData(accChart);
    setNewChartData(newChart);

  }, [data, locale]);

  // 折线图 && 表格
  const options = useMemo(() => {
    const chart = tabName === "newChurn" ? newChartData : accChartData;
    const data_list: Array<listItem> = data || [];
    const tableNon = tabName === "newChurn" ? ['churn_users'] : ['churn_users', 'churn_ratio'];

    // 表头
    let tabbleOption: TableColumn[] = [
      {
        key: 'date',
        align: 'left',
        fixed: 'left',
        width: 100,
        header: getLocalText('engagement_churn_Date'),
        render: (cvm) => {
          const weekDay = getWeekDay(cvm?.date);
          const isSunOrSat = weekDay === 'Sun' || weekDay === 'Sat' || weekDay === '周日' || weekDay === '周六';
          return <>
            <span className='table-text'>{cvm?.date}</span>
            {timeType !== 'Month' && <span className={isSunOrSat ? 'text-week-b' : 'text-week'}>{weekDay}</span>}
          </>;
        },
      },
    ];

    // 表头非固定列
    tableNon?.reduce((pre, key, index) => {
      pre.push({
        key,
        align: 'right',
        width: 150,
        header: doubleChartTitle[index],
        render: (cvm) => <span>{cvm[key]}</span>,
      });
      return pre;
    }, tabbleOption);
    // 表数据
    const tabbleData = tabName === "newChurn" ?
      data_list.reduce((outPre, outCur) => {
        const { date = '', metrics } = outCur;
        const { new_churn_users } = metrics;
        outPre.push({
          date: getChartDateFormatString(timeType, date, true),
          churn_users: formatNum(new_churn_users?.value || '', false, true) + '',
        });
        return outPre;
      }, [] as any[])
      :
      data_list.reduce((outPre, outCur) => {
        const { date = '', metrics } = outCur;
        const { acc_churn_rate, acc_churn_users } = metrics;
        outPre.push({
          date: getChartDateFormatString(timeType, date, true),
          churn_users: formatNum(acc_churn_users?.value || '', false, true) + '',
          churn_ratio: formatPercentNum(parseFloat(acc_churn_rate?.value || ''), 2),
        });
        return outPre;
      }, [] as any[]);

    const tabbleDownloadData = tabName === "newChurn" ?
      data_list.reduce((outPre, outCur) => {
        const { date = '', metrics } = outCur;
        const { new_churn_users } = metrics;
        outPre.push({
          date: getChartDateFormatString(timeType, date, true),
          churn_users: formatExeclNum(new_churn_users?.value || ''),
        });
        return outPre;
      }, [] as any[])
      :
      data_list.reduce((outPre, outCur) => {
        const { date = '', metrics } = outCur;
        const { acc_churn_rate, acc_churn_users } = metrics;
        outPre.push({
          date: getChartDateFormatString(timeType, date, true),
          churn_users: formatExeclNum(acc_churn_users?.value || ''),
          churn_ratio: formatExeclNormalPercent(parseFloat(acc_churn_rate?.value || '')),
        });
        return outPre;
      }, [] as any[]);

    return {
      chart,
      table: {
        option: tabbleOption,
        data: tabbleData,
        downloadData: tabbleDownloadData,
      },
    };
  }, [tabName, accChartData, newChartData]);

  const axisLabelFormat = (opt: any, timeType: any) => {
    return opt.xAxis?.map((item: any) => {
      return {
        ...item,
        axisLabel: {
          ...item.axisLabel,
          formatter: (value: any) => getChartDateFormatString(timeType, value),
        },
      };
    });
  };

  const setOtherConfigFunc = (opt: any, timeType: any) => {
    const y1 = opt.yAxis;
    let y2 = cloneDeep(opt.yAxis);
    y2.alignTicks = true;
    y2.axisLabel.formatter = (value: any) => (value && `${formatPercentNum(value, value < 0.01 ? 2 : 0)}`) || value;

    opt.xAxis = axisLabelFormat(opt, timeType);
    opt.yAxis = [y1, y2];
    opt.series.forEach((y: { yAxisIndex: any; }, i: any) => {
      y.yAxisIndex = i;
    });
    return addChartLabel(opt, {
      formatter: (params: { value: string | number; }) => {
        return formatNum(params?.value, false, true);
      },
      show: isEye,
      formatNum: (value: string | number) => {
        return formatNum(value, false, true);
      }
    });
  };

  const formatterFunc = (params: any) => {
    const id = 'engagement_churn_Churn%';
    return getEchartTooltipText({
      title: EChartTitle || moment(`${params[0].axisValue}`).format('YYYY-MM-DD'),
      metricsName: EChartMetricsName || '',
      data: params.map(({ seriesName, value, color }: any) => ({
        name: seriesName,
        metricsNum: seriesName === getLocalText(id) ? formatPercentNum(parseFloat(value), 2) : formatNum(value, false, true),
        color,
      })),
    });
  };

  return (
    <ChurnChartCo
      options={options}
      tabName={tabName}
      setTabName={setTabName}
      timeType={timeType}
      tabList={tabList}
      title={title}
      titleDes={titleDes}
      isLoading={isLoading}
      isError={isError}
      isNoData={isNoData}
      defaultActive={defaultActive}
      formatterFunc={formatterFunc}
      setOtherConfigFunc={setOtherConfigFunc}
      isEye={isEye}
      setIsEye={setIsEye}
      hideConfig={hideConfig}
    />
  );
};


export default connect((state: any) => {
  return {
    explainInfo: state.dashboard?.explainInfo,
  };
})(WeekChurnUsersNightingaleContext);
